export const getNextCharFactory = firstChar => {
  let index = -1
  return () => {
    index += 1
    return String.fromCharCode(firstChar.charCodeAt(0) + index)
  }
}
